<!-- 忘记密码 -->
<template>
  <div class="forget">
    <!-- 导航栏 -->
    <van-nav-bar title="忘记密码" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <Account />
    <SMS />
    <div class="login-btn">
      <van-button type="danger" @click="navNext">下一步</van-button>
    </div>
  </div>
</template>

<script>
import Account from "./AccountNum";
import SMS from "./SMS";
export default {
  components: { Account, SMS },
  data() {
    return {};
  },
  computed: {},
  methods: {
    select(val) {
      this.value = val;
      this.show = false;
    },
    //  返回上一页
    goBack() {
      this.$router.back();
    },
    navNext() {
      this.$router.push({
        name: "setPassWord"
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.forget {
  padding: 0.9rem 0.3rem 0;
}
.login-btn {
  width: 90%;
  margin: 0.9rem auto 0;
  .van-button {
    width: 100%;
    background: rgba(255, 67, 67, 1);
    border-radius: 0.08rem;
  }
}
</style>